import React, { createElement, useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import InputField from '@vb/components/build/components/forms/inputs/InputField/InputField';
import BreadCrumbs from '@componentsV2/BreadCrumbs';
import { isNativeEnv } from '@/utils/nativeBridge';
import useFetchEffect from '../../../../hooks/useFetchEffect';
import Page from '../../../../components/layouts/WithHeader';
import styles from './style';
import Box from '../../../../components/atomic/Box';
import BoligmappaPlusLogo from '../../../../assets/images/Boligmappa-Plus-Logo.png';
import CallToAction from '../../../../componentsV2/BoligmappaPlus/CallToAction';
import UploadArrowIcon from '../../../../assets/icons/UploadArrowIcon';
import ErrorContainer from '../../../../components/ErrorContainer';
import {
  fetchPersonalDocuments as apiFetchPersonalDocuments,
  fetchPersonalFolders as apiFetchPersonalFolders,
} from '../../../../api/propertyowners';
import { fetchProperties as apiFetchProperties } from '../../../../api/properties';
import {
  sGetFetchingPersonalDocumentFolders,
  sGetFetchingPersonalDocuments,
  sGetFetchingPersonalDocumentsError,
  sGetPersonalDocumentFolders,
  sGetPersonalDocumentFoldersToRender,
  sGetPersonalDocuments,
  sGetPersonalFoldersBreadCrumbs,
} from '../../../../store/reducers/personalDocuments';
import {
  acDeletePersonalDocument,
  acSetFetchingPersonalDocuments,
  acSetFetchingPersonalDocumentsError,
  acSetPersonalDocumentFolders,
  acSetPersonalDocumentFoldersToRender,
  acSetPersonalDocuments,
  acDeletePersonalDocumentFolder,
  acSetSelectedPersonalFolderId,
  acSetPersonalFoldersBreadCrumbs,
  acSetFetchingPersonalDocumentFolders,
} from '../../../../store/actions/personalDocuments';
import {
  acSetDocumentSearchText,
  acSetFetchingDocuments,
} from '../../../../store/actions/documents';
import useDesktop from '../../../../hooks/useDesktop';
import {
  getDocumentList,
  getDocumentTable,
} from '../../../../utils/DocumentTable';
import {
  acSetProperties,
  acSetFetchingProperties,
  acSetFetchingPropertiesError,
} from '../../../../store/actions/properties';
import {
  sGetFetchingProperties,
  sGetPropertiesLoaded,
  sGetFetchingPropertiesError,
} from '../../../../store/reducers/properties';
import { parseQuery } from '../../../../utils/routes';
import ChapterTable from '../../../PrivateRoutes/Dashboard/Documents/ChapterTable';
import ChapterList from '../../../PrivateRoutes/Dashboard/Documents/ChapterList';
import { FileUploadContext } from '../../../../contexts/fileUpload';
import { sGetDocumentSearchText } from '../../../../store/reducers/documents';
import Typography from '../../../../components/atomic/Typography';
import Hidden from '../../../../components/atomic/Hidden';
import AddContextMenu from '../../../PrivateRoutes/Dashboard/AddContextMenu';
import { useBoligmappaPlusSubscriptionStatus } from '../../../../store/hooks/useBoligmappaPlusSubscriptionStatus';
import { boligmappaPlusActionCallback } from '../../../../utils/boligmappaPlus';
import MobileDocumentSearch from '../../../PrivateRoutes/Dashboard/Documents/MobileDocumentSearch';
import matomo from '../../../../utils/matomo';
import useSnackbar from '../../../../hooks/useSnackbar';
import useAddNewDocumentMenu from '../../../../hooks/useAddNewDocumentMenu';
import BaseDialogForm from '../../../../components/forms/BaseDialogForm';
import useDebounce from '../../../../hooks/useDebounce';

const PersonalDocumentsPage = ({
  setPersonalDocumentFetching,
  setPersonalDocumentFoldersFetching,
  setPersonalDocuments,
  setPersonalFoldersBreadCrumbs,
  setPersonalDocumentFolders,
  setPersonalDocumentFoldersToRender,
  setPersonalDocumentFetchingError,
  personalDocuments,
  personalDocumentfetching,
  personalDocumentFoldersFetching,
  personalDocumentFolders,
  personalDocumentFoldersToRender,
  personalFoldersBreadCrumbs,
  fetchingError,
  searchText,
  setSearchText,
  deletePersonalDocument,
  deletePersonalDocumentFolder,
  classes,
  setProperties,
  setFetchingProperties,
  setFetchingPropertiesError,
  propertiesLoaded,
  setSelectedPersonalFolderId,
}) => {
  const isBoligmappaPlusUser = useBoligmappaPlusSubscriptionStatus();
  const [currentDocFolderId, setCurrentDocFolderId] = useState(null);
  const [documentsToRender, setDocumentsToRender] = useState([]);
  const [allDocumentsLoaded, setAllDocumentsLoaded] = useState(false);
  const isDesktop = useDesktop();
  const { search } = useLocation();
  const parsedQuery = parseQuery(search);

  const {
    onFileUploadClick,
    directoryId,
    setDirectoryId,
    directoryTree,
    setDirectoryTree,
  } = useContext(FileUploadContext);
  const documentDebouncedSearch = useDebounce(searchText, 500);
  const [searchQuery, setSearchQuery] = useState(searchText);
  const [isSearching, setIsSearching] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [stickyFiltersHeight, setStickyFiltersHeight] = useState(0);

  const {
    setIsAddingNewDoc,
    isCreatingName,
    setIsCreatingName,
    newFolderName,
    setNewFolderName,
    folderNameErrorMessage,
    isFolderNameError,
    onFolderCreate,
    onCancelCreatingFolder,
  } = useAddNewDocumentMenu({
    currentDocFolderId,
    breadCrumbs: personalFoldersBreadCrumbs,
    isPersonal: true,
  });
  const history = useHistory();

  const [showEmptyListMessage, setShowEmptyListMessage] = useState(
    personalDocuments && personalDocuments?.length === 0
  );

  const { chaptersMode } = parsedQuery || {};
  const { showErrorMessage } = useSnackbar();

  const isApp = isNativeEnv();

  const updateDocsAndFoldersToRender = (folderId) => {
    setCurrentDocFolderId(folderId);
    let foldersToRender = personalDocumentFolders;
    personalFoldersBreadCrumbs.forEach((breadcrumb) => {
      foldersToRender = foldersToRender.find(
        (el) => el.id === breadcrumb.id
      ).directories;
    });
    setPersonalDocumentFoldersToRender(foldersToRender);
    setSelectedPersonalFolderId(folderId);
    setDocumentsToRender(
      personalDocuments.filter((doc) => doc.directoryId === folderId)
    );
  };
  const onFolderChange = (id) => {
    const currentFolder = personalDocumentFoldersToRender.find(
      (folder) => folder.id === id
    );
    setPersonalFoldersBreadCrumbs([
      ...personalFoldersBreadCrumbs,
      currentFolder,
    ]);
  };

  const launchDocsAndFoldersState = ({ folders, docs }) => {
    if (folders) {
      setPersonalDocumentFolders(folders);
      setPersonalDocumentFoldersToRender(folders);
      setSelectedPersonalFolderId(null);
    }
    if (docs) {
      const docsToRender = docs.filter((el) => el.directoryId === null);
      setPersonalDocuments(docs);
      setDocumentsToRender(docsToRender);
    }
  };

  useFetchEffect({
    conditionFunction: () => personalDocuments?.length === 0,
    setFetchingFunction: (data) => setPersonalDocumentFetching(data),
    onSuccess: (data) => launchDocsAndFoldersState({ docs: data.documents }),
    onError: (error) => setPersonalDocumentFetchingError(error),
    apiFetchFunction: () => apiFetchPersonalDocuments(),
  });

  useFetchEffect({
    conditionFunction: () => personalDocumentFolders?.length === 0,
    setFetchingFunction: (data) => setPersonalDocumentFoldersFetching(data),
    onSuccess: (data) =>
      launchDocsAndFoldersState({ folders: data.directories.reverse() }),
    onError: (error) => setPersonalDocumentFetchingError(error),
    apiFetchFunction: () => apiFetchPersonalFolders(),
  });

  useEffect(() => {
    if (!personalDocumentfetching && !personalDocumentFoldersFetching) {
      setAllDocumentsLoaded(true);
    }
  }, [personalDocumentfetching, personalDocumentFoldersFetching]);

  useEffect(() => {
    if (documentsToRender?.length < 1) {
      setShowEmptyListMessage(true);
    } else {
      setShowEmptyListMessage(false);
    }
  }, [documentsToRender]);

  useEffect(() => {
    setDocumentsToRender(
      personalDocuments.filter((doc) => doc.directoryId === currentDocFolderId)
    );
  }, [personalDocuments]);

  useEffect(() => {
    updateDocsAndFoldersToRender(
      personalFoldersBreadCrumbs[personalFoldersBreadCrumbs.length - 1]?.id ||
        null
    );
  }, [personalDocumentFolders]);
  useEffect(() => {
    updateDocsAndFoldersToRender(
      personalFoldersBreadCrumbs[personalFoldersBreadCrumbs.length - 1]?.id ||
        null
    );
  }, [personalFoldersBreadCrumbs]);

  useEffect(() => {
    if (history.action !== 'POP') {
      setPersonalFoldersBreadCrumbs([]);
    }
  }, [history]);

  useEffect(() => {
    const fetchProperties = async () => {
      setFetchingProperties(true);
      const [error, properties] = await apiFetchProperties();
      if (properties && !error) {
        setProperties(properties);
        setFetchingProperties(false);
      }
      if (error) {
        setFetchingPropertiesError(error);
        setFetchingProperties(false);
      }
    };
    if (!propertiesLoaded) {
      fetchProperties();
    }
  }, [propertiesLoaded]);

  useEffect(() => {
    setSearchQuery(documentDebouncedSearch);
  }, [documentDebouncedSearch]);

  useEffect(() => {
    setSearchQuery('');
    setSearchText('');
  }, [personalFoldersBreadCrumbs]);

  const onDocumentUpload = () => {
    if (isDesktop) {
      onFileUploadClick({
        query: {
          bulkUploadMode: true,
          source: 'table',
          newUpload: true,
          isRoomOrEvent: true,
        },
      });
    } else {
      onFileUploadClick({
        query: {
          bulkUploadMode: true,
          source: 'listView',
          newUpload: true,
          isRoomOrEvent: true,
        },
      });
    }
    setIsAddingNewDoc(false);
  };

  const renderMobileBreadCrumbs = () =>
    personalFoldersBreadCrumbs.length > 0 ? (
      <BreadCrumbs
        breadCrumbs={personalFoldersBreadCrumbs}
        breadCrumbsNames={personalFoldersBreadCrumbs.map((el) => el.name)}
        setBreadCrumbs={setPersonalFoldersBreadCrumbs}
        onlyBack
        pathClassName={classes.breadcrumbs}
      />
    ) : (
      <Typography
        className={isDesktop ? classes.headerTitle : classes.headerTitleMobile}
      >
        Alle dokumenter
      </Typography>
    );

  const onDocumentDeleted = (document) => {
    deletePersonalDocument(document);
  };

  const onFolderDelete = (folders) => {
    const folderIds = folders.map((el) => el.id);
    const deletedDocs = personalDocuments.filter((doc) =>
      folderIds.includes(doc.directoryId)
    );
    if ((deletedDocs || []).length > 0) {
      deletedDocs?.forEach((doc) => {
        deletePersonalDocument(doc);
      });
    }

    if (folders.length > 0) {
      folders.forEach((folder) => {
        deletePersonalDocumentFolder(folder);
      });
    }
  };

  const onSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleActionClick = async (type) => {
    matomo.clickEvent({
      category: 'Boligmappa+',
      action: 'Pay with Vipps',
    });
    await boligmappaPlusActionCallback(type, showErrorMessage);
  };

  const mobileHeaderSearch = () => (
    <MobileDocumentSearch
      fullWidth
      value={searchText}
      onChange={onSearchChange}
      placeholder="Søk i dokumenter"
      onClearSearch={() => setSearchText('')}
      isSearching
      setIsSearching={setIsSearching}
    />
  );

  const renderBoligmappaPlusCTA = () => {
    return (
      <div className={classes.boligmappa_plus_subscription_section}>
        <h1>Mine dokumenter</h1>
        <div style={{ display: 'flex' }}>
          <div className={classes.boligmappa_plus_content_text}>
            <p className={classes.boligmappa_plus_personal_text}>
              Dokumenter i personlig område følger deg for alltid. Trygg og
              sikker lagring av viktige dokumenter med BankID. .{' '}
            </p>
            <button type="button" className={classes.boligmappa_plus_logo_btn}>
              Tilgjengelig med
              <img alt="Boligmappa+Logo" src={BoligmappaPlusLogo} />
            </button>
          </div>
          <div>
            <CallToAction
              isDesktop={isDesktop}
              className={clsx([
                classes.personal_area_call_to_action,
                isDesktop && 'desktop',
              ])}
              onActionClick={handleActionClick}
            />
          </div>
        </div>
      </div>
    );
  };

  const changeBreadCrumb = (index) => {
    setPersonalFoldersBreadCrumbs(
      personalFoldersBreadCrumbs.slice(0, index + 1)
    );
  };

  const rootBreadCrumb = () => {
    setPersonalFoldersBreadCrumbs([]);
  };

  const renderHeaderBreadCrumbs = () => {
    const breadCrumbsNames = personalFoldersBreadCrumbs
      .map((el) => el.name)
      .slice(0, -1);
    return (
      <div className="flex overflow-hidden">
        <>
          <div>
            <button
              type="button"
              className={classes.breadCrumbButton}
              onClick={rootBreadCrumb}
            >
              <p style={{ color: '#717171' }}>Alle dokumenter</p>
            </button>
          </div>
          {breadCrumbsNames.length > 0 && (
            <div style={{ color: '#717171' }}>/</div>
          )}
        </>
        {breadCrumbsNames.map((el, index) => (
          <>
            {index + 1 !== breadCrumbsNames.lenght && (
              <div>
                <button
                  type="button"
                  className={classes.breadCrumbButton}
                  onClick={() => changeBreadCrumb(index)}
                >
                  <p style={{ color: '#717171' }}>{el}</p>
                </button>
              </div>
            )}
            {index + 1 !== breadCrumbsNames.length && (
              <div style={{ color: '#717171' }}>/</div>
            )}
          </>
        ))}
      </div>
    );
  };

  const renderTable = () => {
    if (chaptersMode) {
      return createElement(isDesktop ? ChapterTable : ChapterList, {
        documents: personalDocuments,
        fetchingDocuments: personalDocumentfetching,
        fetchingDocumentsError: fetchingError,
        searchQuery,
      });
    }
    return createElement(isDesktop ? getDocumentTable() : getDocumentList(), {
      fetching: !allDocumentsLoaded,
      documents: documentsToRender,
      onFolderChange,
      documentFolders: personalDocumentFoldersToRender,
      directoryId: directoryId || currentDocFolderId,
      setDirectoryId,
      searchQuery,
      directoryTree,
      setDirectoryTree,
      showBulkSelectionOptions: true,
      onDocumentDeleted,
      isPersonalDocuments: true,
      fetchingError,
      isFromPersonal: true,
      headerHeight,
      setStickyFiltersHeight,
      isBoligmappaPlusUser,
      onFolderDelete,
    });
  };

  return (
    <Page
      topLevelLayout
      document
      showBackButton={false}
      headerTitle={renderMobileBreadCrumbs()}
      headerSearch={mobileHeaderSearch()}
      isSearching={isSearching}
      setHeaderHeight={setHeaderHeight}
      noPadding={!isDesktop}
    >
      {fetchingError ? (
        <ErrorContainer
          paddingTop={isDesktop}
          errorResponse={fetchingError}
          style={{ paddingTop: isDesktop ? undefined : '15%' }}
        />
      ) : (
        <Box
          className={isDesktop && classes.mobilePadding}
          style={{ marginTop: stickyFiltersHeight }}
        >
          {isDesktop &&
            !isApp &&
            isBoligmappaPlusUser !== undefined &&
            !isBoligmappaPlusUser &&
            renderBoligmappaPlusCTA()}
          <div>
            {personalFoldersBreadCrumbs.length > 0 ? (
              <Box flex="none">
                {renderHeaderBreadCrumbs()}
                <Typography
                  className={
                    isDesktop ? classes.headerTitle : classes.headerTitleMobile
                  }
                >
                  {personalFoldersBreadCrumbs.slice(-1)[0]?.name}
                </Typography>
              </Box>
            ) : (
              <Typography
                className={
                  isDesktop ? classes.headerTitle : classes.headerTitleMobile
                }
              >
                Alle dokumenter
              </Typography>
            )}
          </div>
          <Box mt={1}>{renderTable()}</Box>
          {showEmptyListMessage && !personalDocumentfetching && (
            <Box
              onClick={onDocumentUpload}
              className={
                isBoligmappaPlusUser
                  ? classes.documentUploadbox
                  : classes.DisableddocumentUploadbox
              }
            >
              <UploadArrowIcon height="32px" width="32px" />
              <Typography sx={{ textAlign: 'center' }}>
                {isBoligmappaPlusUser
                  ? 'Last opp dokumenter til mappen!'
                  : 'Kjøp et abonnement for å laste opp dine første dokumenter.'}
              </Typography>
            </Box>
          )}

          {!isDesktop && (
            <BaseDialogForm
              open={isCreatingName}
              header="Ny mappe"
              onSubmit={onFolderCreate}
              onClose={onCancelCreatingFolder}
            >
              <div className={classes.mobileCreateFolderContent}>
                <InputField
                  type="text"
                  label="Opprett mappe:"
                  value={newFolderName}
                  placeholder="Skriv inn mappenavn"
                  onChange={(event) => setNewFolderName(event.target.value)}
                />
                {isFolderNameError && (
                  <p className={classes.errorMessage}>
                    {folderNameErrorMessage}
                  </p>
                )}
              </div>
            </BaseDialogForm>
          )}

          {/* Mobile only */}

          {!isApp &&
            !isDesktop &&
            !isBoligmappaPlusUser &&
            renderBoligmappaPlusCTA()}

          <Hidden mdUp>
            {!isDesktop && isBoligmappaPlusUser && (
              <AddContextMenu
                isFromPersonal
                isBoligmappaPlusUser={isBoligmappaPlusUser}
                onMobileFolderCreate={() => setIsCreatingName(true)}
                //                folderFeatureFlag={true}
              />
            )}
          </Hidden>
        </Box>
      )}
    </Page>
  );
};

const mapStateToProps = (state) => ({
  fetchingError: sGetFetchingPersonalDocumentsError(state),
  personalDocumentfetching: sGetFetchingPersonalDocuments(state),
  personalDocumentFoldersFetching: sGetFetchingPersonalDocumentFolders(state),
  personalDocuments: sGetPersonalDocuments(state),
  personalDocumentFolders: sGetPersonalDocumentFolders(state),
  personalDocumentFoldersToRender: sGetPersonalDocumentFoldersToRender(state),
  personalFoldersBreadCrumbs: sGetPersonalFoldersBreadCrumbs(state),
  searchText: sGetDocumentSearchText(state),
  fetchingProperties: sGetFetchingProperties(state),
  propertiesLoaded: sGetPropertiesLoaded(state),
  fetchingPropertiesError: sGetFetchingPropertiesError(state),
});

const mapDispatchToProps = (dispatch) => ({
  setPersonalDocumentFetchingError: (fetchingError) =>
    dispatch(acSetFetchingPersonalDocumentsError(fetchingError)),
  setPersonalDocuments: (documents) =>
    dispatch(acSetPersonalDocuments(documents)),
  setPersonalDocumentFolders: (folders) =>
    dispatch(acSetPersonalDocumentFolders(folders)),
  setPersonalDocumentFoldersToRender: (folders) =>
    dispatch(acSetPersonalDocumentFoldersToRender(folders)),
  setPersonalFoldersBreadCrumbs: (breadCrumbs) =>
    dispatch(acSetPersonalFoldersBreadCrumbs(breadCrumbs)),
  setFetching: (fetching) => dispatch(acSetFetchingDocuments(fetching)),
  setSearchText: (searchText) => dispatch(acSetDocumentSearchText(searchText)),
  setPersonalDocumentFetching: (fetching) =>
    dispatch(acSetFetchingPersonalDocuments(fetching)),
  setPersonalDocumentFoldersFetching: (fetching) =>
    dispatch(acSetFetchingPersonalDocumentFolders(fetching)),
  deletePersonalDocument: (document) =>
    dispatch(acDeletePersonalDocument(document)),
  deletePersonalDocumentFolder: (folder) =>
    dispatch(acDeletePersonalDocumentFolder(folder)),
  setProperties: (properties) => dispatch(acSetProperties(properties)),
  setFetchingProperties: (fetching) =>
    dispatch(acSetFetchingProperties(fetching)),
  setFetchingPropertiesError: (error) =>
    dispatch(acSetFetchingPropertiesError(error)),
  setSelectedPersonalFolderId: (id) =>
    dispatch(acSetSelectedPersonalFolderId(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PersonalDocumentsPage));
